import moment from "moment";

export const transform = (data) => ({
	...data,
	start_at:
		data.start_at && moment(data.start_at).format("YYYY-MM-DD HH:mm:ss"),
	end_at: data.end_at && moment(data.end_at).format("YYYY-MM-DD HH:mm:ss"),
});
